document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-lb-rec-desktop-slider]');

  sliders.forEach(async (slider) => {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    if (slider.dataset.lbRecReady === 'true') return;
    slider.dataset.lbRecReady = 'true';

    const collectionUrl = slider.dataset.collectionUrl;
    const maxProducts = parseInt(slider.dataset.maxProducts || '8', 10);

    const track = slider.querySelector('[data-lb-rec-track]');
    const viewport = slider.querySelector('[data-lb-rec-viewport]');
    let prevBtn = slider.querySelector('[data-lb-rec-prev]');
    let nextBtn = slider.querySelector('[data-lb-rec-next]');

    if (!collectionUrl || !track || !viewport || !prevBtn || !nextBtn) return;

    try {
      const res = await fetch(collectionUrl, {
        credentials: 'same-origin',
        cache: 'force-cache'
      });

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const items = Array.from(
        doc.querySelectorAll('#ResultsList ul.product-grid > li.product-grid__item')
      ).slice(0, maxProducts);

      if (!items.length) return;

      const baseSlides = items.map((item) => {
        const slide = document.createElement('div');
        slide.className = 'lb-rec-desktop__slide';
        slide.setAttribute('data-lb-rec-slide', '');
        slide.appendChild(item.cloneNode(true));
        cleanClone(slide);
        return slide;
      });

      buildInfiniteDesktopSlider(slider, track, prevBtn, nextBtn, baseSlides);
    } catch (e) {
      console.warn('LB recommendations desktop slider load failed:', e);
    }
  });

  function cleanClone(node) {
    node.removeAttribute('id');

    node.querySelectorAll('[id]').forEach((el) => {
      el.removeAttribute('id');
    });

    node.querySelectorAll('style[data-shopify]').forEach((el) => {
      el.remove();
    });

    node.querySelectorAll('[data-real], [data-clone]').forEach((el) => {
      el.removeAttribute('data-real');
      el.removeAttribute('data-clone');
    });

    return node;
  }

  function buildInfiniteDesktopSlider(slider, track, prevBtn, nextBtn, baseSlides) {
    const transition = 'transform 0.45s cubic-bezier(.22,.61,.36,1)';

    let currentIndex = 0;
    let isAnimating = false;
    let resizeTimer = null;
    let lastWidth = window.innerWidth;

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function getPerView() {
      const raw = getComputedStyle(slider).getPropertyValue('--lb-rec-columns-desktop');
      return Math.max(1, parseInt(raw, 10) || 4);
    }

    function getAllSlides() {
      return Array.from(track.children);
    }

    function getOffset(index) {
      const slide = getAllSlides()[index];
      return slide ? slide.offsetLeft : 0;
    }

    function setTranslate(x) {
      track.style.transform = `translate3d(-${x}px, 0, 0)`;
    }

    function jumpTo(index) {
      track.style.transition = 'none';
      currentIndex = index;
      setTranslate(getOffset(currentIndex));
      track.offsetHeight;
    }

    function animateTo(index) {
      isAnimating = true;
      currentIndex = index;
      updateArrows();

      track.style.transition = transition;
      setTranslate(getOffset(currentIndex));
    }

    function updateArrows() {
      prevBtn.disabled = isAnimating;
      nextBtn.disabled = isAnimating;
    }

    function cloneSlideExactly(baseSlide) {
      const clone = baseSlide.cloneNode(true);
      clone.classList.add('lb-rec-inf-slide');
      cleanClone(clone);
      return clone;
    }

    function buildTrack() {
      if (!baseSlides.length) return false;

      const cloneCount = Math.min(Math.max(getPerView(), 2), baseSlides.length);

      const beforeSlides = baseSlides.slice(-cloneCount).map(cloneSlideExactly);
      const realSlides = baseSlides.map(cloneSlideExactly);
      const afterSlides = baseSlides.slice(0, cloneCount).map(cloneSlideExactly);

      track.innerHTML = '';

      beforeSlides.forEach((slide) => {
        slide.dataset.clone = 'before';
        track.appendChild(slide);
      });

      realSlides.forEach((slide) => {
        slide.dataset.real = 'true';
        track.appendChild(slide);
      });

      afterSlides.forEach((slide) => {
        slide.dataset.clone = 'after';
        track.appendChild(slide);
      });

      currentIndex = cloneCount;
      jumpTo(currentIndex);
      updateArrows();

      return true;
    }

    function getBounds() {
      const realSlides = track.querySelectorAll('.lb-rec-inf-slide[data-real="true"]');
      const cloneCount = Math.min(Math.max(getPerView(), 2), realSlides.length);

      return {
        firstReal: cloneCount,
        lastReal: cloneCount + realSlides.length - 1
      };
    }

    function normalizeLoop() {
      const realSlides = track.querySelectorAll('.lb-rec-inf-slide[data-real="true"]');
      if (!realSlides.length) return;

      const bounds = getBounds();

      if (currentIndex > bounds.lastReal) {
        jumpTo(bounds.firstReal);
      } else if (currentIndex < bounds.firstReal) {
        jumpTo(bounds.lastReal);
      }
    }

    function next() {
      if (isAnimating) return;
      animateTo(currentIndex + 1);
    }

    function prev() {
      if (isAnimating) return;
      animateTo(currentIndex - 1);
    }

    const prevClone = prevBtn.cloneNode(true);
    const nextClone = nextBtn.cloneNode(true);

    prevBtn.replaceWith(prevClone);
    nextBtn.replaceWith(nextClone);

    prevBtn = prevClone;
    nextBtn = nextClone;

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      prev();
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      next();
    });

    track.addEventListener('transitionend', (e) => {
      if (e.target !== track) return;

      normalizeLoop();
      isAnimating = false;
      updateArrows();
    });

    window.addEventListener('resize', () => {
      if (!isDesktop()) return;

      const newWidth = window.innerWidth;
      if (newWidth === lastWidth) return;

      lastWidth = newWidth;

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        jumpTo(currentIndex);
        updateArrows();
      }, 180);
    });

    const ok = buildTrack();
    if (!ok) return;

    updateArrows();
  }
});